<div class="col-md-15 ui-g-2">
  <p-card styleClass="ui-card-shadow" [style]="{background: 'linear-gradient(229deg, #fd9a77, #fb827a)'}">
    <p-header>
      <span class="font-card-new">Moderation disponible</span>
    </p-header>
    <div>
      <i class="pi pi-clone"></i>
      <span class="font-card-new">120</span>
    </div>
  </p-card>
</div>
<div class="col-md-15 ui-g-2">
  <p-card styleClass="ui-card-shadow" [style]="{background: 'linear-gradient(229deg, #9E4800, #DE730D)'}">
    <p-header>
      <span class="font-card-new">Retour disponible</span>
    </p-header>
    <i class="pi pi-user-edit"></i>
    <span class="font-card-new">30</span>
  </p-card>
</div>
<div class="col-md-15 ui-g-2">
  <p-card styleClass="ui-card-shadow" [style]="{background: 'linear-gradient(229deg, #8edead, #43c6ac)'}">
    <p-header>
      <span class="font-card-new">Nombre Moderation traité</span>
    </p-header>
    <i class="pi pi-folder"></i>
    <span class="font-card-new">11</span>
  </p-card>
</div>
<div class="col-md-15 ui-g-2">
  <p-card styleClass="ui-card-shadow" [style]="{background: 'linear-gradient(248deg, #348ac7, #7474bf)'}">
    <p-header>
      <span class="font-card-new">Nombre contenu traité</span>
    </p-header>
    <i class="pi pi-file" [style]="{color: '#b81b00'}"></i>
    <span class="font-card-new">11</span>
  </p-card>
</div>
<div class="col-md-15 ui-g-2">
  <p-card styleClass="ui-card-shadow" [style]="{background: 'linear-gradient(67deg, #f15f79, #b24592)'}">
    <p-header>
      <span class="font-card-new">Utilisateurs connectés</span>
    </p-header>
    <i class="pi pi-user"></i>
    <span class="font-card-new">11</span>
  </p-card>
</div>
